import React from 'react'
import EmailSignupForm from './signup_form'

function signup(email) {
  window.pipetteEvents?.newsletterSubscribed(email)
  return 'Thank you for signing up!'
}

export default function NewsletterSignup() {
  return <EmailSignupForm submit={signup} type='newsletter' />
}
